import { render, staticRenderFns } from "./platformRevenue.vue?vue&type=template&id=72a0a0b5&scoped=true&"
import script from "./platformRevenue.vue?vue&type=script&lang=js&"
export * from "./platformRevenue.vue?vue&type=script&lang=js&"
import style0 from "./platformRevenue.vue?vue&type=style&index=0&id=72a0a0b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0a0b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72a0a0b5')) {
      api.createRecord('72a0a0b5', component.options)
    } else {
      api.reload('72a0a0b5', component.options)
    }
    module.hot.accept("./platformRevenue.vue?vue&type=template&id=72a0a0b5&scoped=true&", function () {
      api.rerender('72a0a0b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/revenueSsharing/platformRevenue.vue"
export default component.exports